import { QUIZ_GAME_MAX_DELTA, QUIZ_RUBRIC_MAX_POINTS } from "./constants";

/**
 * Quizzes con rúbrica: cada opción lleva `points` (0–maxPoints).
 * El incremento del acumulado del grupo (`group.score`) es proporcional a `maxGameDelta`
 * (100 pts de rúbrica → +10 pt al marcador; 50 → +5).
 */

/**
 * @param {number} points
 * @param {number} [maxPoints=QUIZ_RUBRIC_MAX_POINTS]
 * @param {number} [maxGameDelta=QUIZ_GAME_MAX_DELTA]
 * @returns {number} delta de puntuación (una decimal como mucho)
 */
export function rubricPointsToScoreDelta(
	points,
	maxPoints = QUIZ_RUBRIC_MAX_POINTS,
	maxGameDelta = QUIZ_GAME_MAX_DELTA
) {
	const p = Number(points);
	const maxP = Number(maxPoints);
	if (!Number.isFinite(p) || !Number.isFinite(maxP) || maxP <= 0) return 0;
	const clamped = Math.max(0, Math.min(maxP, p));
	const raw = (clamped / maxP) * maxGameDelta;
	return Math.round(raw * 10) / 10;
}

/**
 * Etiqueta para modales/UI: convierte rúbrica (100/50/0) a puntos de marcador (10/5/0).
 * @param {number} rubricPoints
 * @returns {string} p. ej. "10 puntos"
 */
export function formatRubricAsGamePointsLabel(rubricPoints) {
	const delta = rubricPointsToScoreDelta(rubricPoints);
	let s = delta.toFixed(1);
	if (s.endsWith(".0")) s = s.slice(0, -2);
	return `${s} puntos`;
}

/**
 * @param {Array<{ points?: unknown }>} options
 * @returns {boolean}
 */
export function quizOptionsAreWeighted(options) {
	return (
		Array.isArray(options) &&
		options.length > 0 &&
		options.every((o) => typeof o.points === "number" && Number.isFinite(o.points))
	);
}
